import { convertToQueryString } from 'app/shared/functions';
import { HttpClient } from 'app/library/client';
import { IListFilter, ResponseBase, ResponseContentBase, ResponseListBase } from "app/shared";
import { ActivityGroupEntity } from './types';
import { getEndpoint } from 'app/utils/service';

export class ActivityGroupService {

    /** It gets all ActivityGroup. */
    async getActivityGroups(options: IListFilter): Promise<ResponseBase<ResponseListBase<ActivityGroupEntity[]>>> {
        return HttpClient.getClient().get(getEndpoint('/activity-group/search') + `?${convertToQueryString(options)}`);
    }

    /** It get spesific ActivityGroup by ActivityGroup id */
    async getActivityGroup(id: string, language: string): Promise<ResponseBase<ResponseContentBase<ActivityGroupEntity>>> {
        return HttpClient.getClient().get(getEndpoint('/activity-group/') + id + `?language=${language || "en"}`);
    }

    /** It creates ActivityGroup by request */
    async createActivityGroup(request: ActivityGroupEntity): Promise<ResponseBase<ResponseContentBase<ActivityGroupEntity>>> {
        return HttpClient.getClient().post(getEndpoint('/activity-group/'), request);
    }

    /** It updates spesific ActivityGroup by id */
    async updateActivityGroup(request: ActivityGroupEntity): Promise<ResponseBase<boolean>> {
        return HttpClient.getClient().patch(getEndpoint('/activity-group/') + request.id, request);
    }

    /** It deletes spesific ActivityGroup by id */
    async deleteActivityGroup(id: string): Promise<ResponseBase<boolean>> {
        return HttpClient.getClient().delete(getEndpoint('/activity-group/') + id);
    }
}
